<template>
  <div
    class="md:w-[350px] w-[280px] text-center flex flex-col items-center justify-center px-2 pt-2 pb-8"
  >
    <Component
      :is="illustrations[type]"
      class="w-[200px] h-[200px] md:w-[160px] md:h-[160px]"
    />
    <div class="flex flex-col gap-3">
      <div class="text-primary font-medium text-2xl md:text-xl">
        {{ title }}
      </div>
      <div class="flex flex-col gap-4">
        <div class="text-tertiary font-normal text-base md:text-sm">
          <span v-for="(line, index) in splitText" :key="index">
            {{ line }}
            <br />
          </span>
        </div>
        <div class="flex items-center justify-center">
          <Component :is="action.component">
            <Button
              v-if="button"
              variant="secondary"
              type="gray"
              :disabled="disabled"
              :label="button"
              :size="maxSmall ? 'lg' : 'sm'"
              @click="($event) => action.callback($event)"
            />
          </Component>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import * as illustrations from "@/SharedComponents/State/Types";
import { types } from "@/SharedComponents/State/Types";
import { Button } from "@/SharedComponents/Buttons";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { FilesUploadDialog } from "@/SharedComponents/FilesUploadDialog";

const { maxSmall } = useBreakpoints();
const emit = defineEmits(["click:button"]);

const props = defineProps({
  type: {
    type: String,
    validator: (val) => types.includes(val),
    required: false,
  },
  title: { type: String, required: true },
  text: { type: String, required: true },
  button: { type: String, required: false },
  disabled: { type: Boolean, default: false },
  action: { type: String, required: false },
});

const splitText = computed(() => props.text.split("\\n"));

const action = computed(() => {
  switch (props.action) {
    case "add-task":
      return {
        component: "div",
        callback: () => emit("click:button"),
      };
    case "add-file":
      return {
        component: FilesUploadDialog,
        callback: () => emit("click:button"),
      };
    default:
      return {
        component: "div",
        callback: (e) => {
          e.stopPropagation();
          emit("click:button");
        },
      };
  }
});
</script>
